import { makeStyles } from '@mui/styles';

const ButtonsContainerStyles= makeStyles({
    cancelButton: {
        background: '#F7F7F7',
        borderColor: '#F7F7F7',
        width: '87px',
        height: '30px',
        justifyContent: 'center'
    },
    saveButton: {
        background: '#2E3F58',
        borderColor: '#707070',
        width: '87px',
        height: '30px',
        justifyContent: 'center'
    },
    verifyButtonsContainer: {
        display: 'flex',
        justifyContent: 'end',
        marginRight: '10px',
        marginBottom: '10px',
    },
    headerContainer: {
        marginBottom: '15px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    separator: {
        marginLeft: '15px',
        marginRight: '15px',
    },
    labelColor:{
        color: '#2E3F58'
    }
});

export default ButtonsContainerStyles;